import { useLocation } from 'react-router-dom';

const PAGE_MAP = {
  dashboard: 'Dashboard',
  wall: 'Wall',
  Wall: 'Wall',
  teams: 'Teams',
  teamslist: 'Teams List',
  teamusers: 'Team Users',
  designmate: 'DesignMate',
  'tech-pack': 'Tech Pack',
  createproduct: 'Create Product',
  productDetail: 'Product Detail',
  productImgDetail: 'Product Image Detail',
  viewproducts: 'View Products',
  createteam: 'Create Team',
  jointeam: 'Join Team',
  categories: 'Categories',
  tags: 'Tags',
  seasons: 'Seasons',
  fabrics: 'Fabrics',
  ColorLibrary: 'Color Library',
  Tasks: 'Tasks',
  Notification: 'Notifications',
  globalSearch: 'Global Search',
  SearchResult: 'Search Results',
  setting: 'Settings',
  HelpSupport: 'Help & Support',
  plans: 'Pricing',
};

export function useAssistantContext() {
  const location = useLocation();

  const buildContext = () => {
    const path = location.pathname.replace(/^\//, '');
    const firstSegment = path.split('/')[0];
    const currentPage = PAGE_MAP[firstSegment] || firstSegment || 'Dashboard';

    // Read basic user info from localStorage — no PII (no email/phone)
    let teams = [];
    let userRole = null;
    try {
      const raw = localStorage.getItem('userDetails');
      if (raw) {
        const details = JSON.parse(raw);
        if (Array.isArray(details.teamRolePermissions)) {
          teams = details.teamRolePermissions.map((t) => t.teamId).filter(Boolean);
        }
        if (details.role) userRole = details.role;
      }
    } catch (_) {}

    const ctx = { currentPage };
    if (teams.length) ctx.teams = teams;
    if (userRole) ctx.userRole = userRole;

    return ctx;
  };

  return { buildContext };
}
